import React from "react";
// import { useTranslation } from "react-i18next";
import LogoKostrad from "../../../assets/images/2026/general/logo-kostrad.png";
import TextRunWithHonor from "../../../assets/images/2026/general/text-run-with-honor.png";
import TextTanggalLokasiHero from "../../../assets/images/2026/general/text-tanggal-lokasi-hero.png";
import BtnRegisterNow from "../../../assets/images/2026/general/btn-register-now.png";
import OrnamentMonas from "../../../assets/images/2026/general/ornament-monas.png";
import OrnamentPerson from "../../../assets/images/2026/general/ornament-person.png";
import Logo65Kostrad from "../../../assets/images/2026/general/logo-65-kostrad.png";

export default function Hero() {
    // const { t } = useTranslation();
    return (
        <div className="w-full min-h-screen lg:min-h-[720px] h-full relative md:top-[180px] lg:top-[128px]">
            <div className="w-full text-[#164481]">
                <div className="container mx-auto w-full relative h-full lg:px-24">
                    <div className="flex flex-col lg:flex-row max-lg:flex-wrap items-center justify-between relative">
                        <div id="hero-left" className="flex flex-col items-center justify-center lg:basis-5/12">
                            <img src={LogoKostrad} alt="" className="w-72 md:max-lg:w-96" />
                            <img src={TextRunWithHonor} alt="" className="w-64" />
                            <img src={TextTanggalLokasiHero} alt="" className="w-64" />
                            <img src={BtnRegisterNow} alt="" className="w-52 cursor-pointer hover:scale-105 transition-all duration-300" onClick={() => window.location.href = "/registration"} />
                        </div>
                        <div id="hero-right" className="relative flex flex-col items-end justify-center lg:basis-7/12">
                            <div className="relative w-[320px] lg:w-[440px] h-[320px] lg:h-[440px] top-12 md:max-lg:top-36 lg:top-8">
                                <img src={OrnamentMonas} alt="" className="absolute md:max-lg:-bottom-8 bottom-0 w-[320px] md:max-lg:w-[540px] lg:w-[540px] h-[320px] md:max-lg:h-[640px] lg:h-[540px] object-contain z-10" />
                                <img src={OrnamentPerson} alt="" className="absolute bottom-2 w-[240px] md:max-lg:w-[380px] lg:w-[380px] h-[240px] md:max-lg:h-[490px] lg:h-[380px] object-contain z-20 left-8" />
                            </div>
                            <div className="absolute -right-4 w-[72px] lg:w-[108px] h-[72px] md:max-lg:h-[0px] lg:h-[108px]">
                                <img src={Logo65Kostrad} alt="" className="absolute bottom-0 w-[108px] h-[108px] object-contain z-30" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
